import client from "api/client";

// F1 — contentApi. Listing and lifecycle actions on website-scoped
// /websites/{websiteId}/contents. The website comes from the path, so
// `website_id` is never sent in query params or bodies.

export const listContent = async (websiteId, params = {}) => {
  const { data } = await client.get(`/websites/${websiteId}/contents`, { params });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getContent = async (websiteId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/contents/${id}`);
  return data;
};

export const deleteContent = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/contents/${id}`);
};

export const publishContent = async (websiteId, id) => {
  const { data } = await client.post(`/websites/${websiteId}/contents/${id}/publish`);
  return data;
};

export const unpublishContent = async (websiteId, id) => {
  const { data } = await client.post(`/websites/${websiteId}/contents/${id}/unpublish`);
  return data;
};

export const archiveContent = async (websiteId, id) => {
  const { data } = await client.post(`/websites/${websiteId}/contents/${id}/archive`);
  return data;
};
